module.exports = __webpack_public_path__ + "media/brands/oldsmobile-a02e5404.png";